import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-navy-dark text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <h3 className="text-xl sm:text-2xl font-bold mb-4">おかやまネジ製作所</h3>
            <p className="text-gray-300 text-sm sm:text-base leading-relaxed">
              岡山市から全国へ、精密加工技術をお届けします
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-base sm:text-lg font-bold mb-4">サービス</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-300 text-sm sm:text-base hover:text-white transition-colors">
                  特注ネジ製作
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 text-sm sm:text-base hover:text-white transition-colors">
                  難削材加工
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 text-sm sm:text-base hover:text-white transition-colors">
                  小ロット対応
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 text-sm sm:text-base hover:text-white transition-colors">
                  短納期対応
                </a>
              </li>
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-base sm:text-lg font-bold mb-4">会社情報</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/company" className="text-gray-300 text-sm sm:text-base hover:text-white transition-colors">
                  会社概要
                </Link>
              </li>
              <li>
                <Link to="/business" className="text-gray-300 text-sm sm:text-base hover:text-white transition-colors">
                  事業内容
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-300 text-sm sm:text-base hover:text-white transition-colors">
                  製品・工場案内
                </Link>
              </li>
              <li>
                <Link to="/recruit" className="text-gray-300 text-sm sm:text-base hover:text-white transition-colors">
                  求人情報
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-base sm:text-lg font-bold mb-4">お問い合わせ</h4>
            <ul className="space-y-3 text-gray-300 text-sm sm:text-base">
              <li>
                <strong className="text-white">電話:</strong>{' '}
                <a href="tel:086-012-3456" className="hover:text-white transition-colors">
                  086-012-3456
                </a>
              </li>
              <li>
                <strong className="text-white">FAX:</strong> 086-012-3457
              </li>
              <li>
                <strong className="text-white">営業時間:</strong> 9:00-18:00
              </li>
              <li>
                <strong className="text-white">定休日:</strong> 日曜・祝日
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex justify-center items-center">
            <p className="text-gray-300 text-sm text-center">
              © 2025 おかやまネジ製作所 All rights reserved
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;